import { BinderService } from '@/services/api/binder.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { SiteFieldHighlightService } from '@/services/app/site-field-highlight.service';
import { Component, effect } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TaxDataService } from 'src/app/services/app/tax-data.service';

@Component({
    selector: 'app-tax-error',
    imports: [ButtonModule],
    template: `
    <div class="max-w-[50%] mx-auto w-fit">
      <span class="p-text-secondary block mb-8 text-center">{{taxDataService.taxError().message}}</span>
      <div class="flex justify-content-center gap-2">
          <p-button [disabled]="loading" label="Cancel" severity="secondary" (click)="cancel()" />
          <p-button [disabled]="loading" [icon]="loading ? 'pi pi-spin pi-spinner' : ''" label="Retry" (click)="retry()" />
          <p-button [disabled]="loading" label="Enter Manually" (click)="enterManually()" />
      </div>
    </div>
  `
})
export class TaxErrorComponent {
  public loading = false;

  constructor(
    public taxDataService: TaxDataService,
    private binderDialogService: BinderDialogService,
    private currentBinderService: BinderService,
    private siteFieldHighlightService: SiteFieldHighlightService
  ) {
  }

  enterManually() {
    this.cancel();
    this.currentBinderService.patchBinder({TaxOverride: true});
    this.binderDialogService.toggleDialog('Design Criteria', 'design',true);
    this.siteFieldHighlightService.highlightTaxFields();
  }

  retry() {
    this.cancel();
    this.taxDataService.getTax(this.currentBinderService.currentBinder());
  }

  cancel() {
    this.binderDialogService.toggleDialog('', 'tax-error', false);
    this.taxDataService.clearTaxError();
  }

}
